import { useState } from "react";
import { C } from "../constants/colors";
import { TYPE_STYLE } from "../constants/opportunities";
import { Logo } from "../components/ui/Logo";
import { SearchScreen } from "./SearchScreen";
import { OppModal } from "../components/OppModal";

const FUTURA = "'Futura','Century Gothic','Trebuchet MS',sans-serif";
const TYPE_CARD = {
  exhibition: { text:"#c43020", footerBg:"#c43020", footerText:"#f5ede8" },
  grant:      { text:"#0f2d52", footerBg:"#0f2d52", footerText:"#e8e2d9" },
  residency:  { text:"#1e4d32", footerBg:"#1e4d32", footerText:"#dff0e8" },
  open_call:  { text:"#7a5000", footerBg:"#d4940a", footerText:"#1a0e00" },
  opencall:   { text:"#7a5000", footerBg:"#d4940a", footerText:"#1a0e00" },
};

export function PublicSite({ onLogin, onSignupArtist, onSignupGallery, bp, opportunities, artists, currentProfile }) {
  const [view, setView]         = useState("home");
  const [modal, setModal]       = useState(null);
  const [typeF, setTypeF]       = useState("All");
  const [tagF, setTagF]         = useState("all");
  const [searching, setSearching]   = useState(false);

  const filtered = opportunities.filter(o=>{
    const tm = typeF==="All"||(typeF==="Exhibitions"&&o.type==="exhibition")||(typeF==="Grants"&&o.type==="grant")||(typeF==="Residencies"&&o.type==="residency");
    const gm = tagF==="all"||o.tag===tagF;
    return tm&&gm;
  });

  if (searching) return <SearchScreen onBack={()=>setSearching(false)} bp={bp} opportunities={opportunities} artists={artists}/>;

  const NAV = [
    { id:"home",          label:"Home"          },
    { id:"opportunities", label:"Opportunities" },
    { id:"artists",       label:"Artists"       },
  ];

  return (
    <>
      <nav className="topnav">
        <button onClick={()=>{setView("home");}} style={{ background:"none",border:"none",padding:0,cursor:"pointer" }}><Logo/></button>
        {bp!=="mobile"&&(
          <div style={{ display:"flex",gap:4 }}>
            {NAV.map(n=>(
              <button key={n.id} className={`nav-lnk ${view===n.id?"on":""}`} onClick={()=>setView(n.id)}>{n.label}</button>
            ))}
          </div>
        )}
        <div style={{ display:"flex",gap:7,alignItems:"center" }}>
          <button onClick={()=>setSearching(true)} style={{ background:"rgba(255,255,255,.08)",border:"none",borderRadius:4,padding:"6px 10px",color:C.mutedL,fontSize:".8rem",minHeight:36,display:"flex",alignItems:"center",gap:5 }}>🔍</button>
          <button className="btn-dk" style={{ fontSize:".66rem",padding:"7px 13px",minHeight:38 }} onClick={onLogin}>Log in</button>
          <button className="btn-p" style={{ fontSize:".66rem",padding:"7px 13px",minHeight:38 }} onClick={onSignupArtist}>Join free</button>
        </div>
      </nav>

      <div style={{ paddingBottom:bp!=="desktop"?72:0 }}>

        {/* HOME */}
        {view==="home"&&<>
          <div className="hero" style={{ background:"#f0ece2" }}>
            <div style={{ position:"relative",zIndex:1 }}>
              <div style={{ fontFamily:"'DM Mono',monospace",fontSize:9,letterSpacing:"0.2em",textTransform:"uppercase",color:"rgba(26,18,9,0.3)",marginBottom:16 }}>Australian artists & galleries</div>
              <h1 style={{ fontFamily:FUTURA,fontWeight:900,fontSize:"clamp(3.5rem,10vw,6.5rem)",lineHeight:0.85,letterSpacing:"-0.04em",textTransform:"uppercase",color:"#1a1209",marginBottom:32 }}>
                Find your<br/>next <em style={{ fontStyle:"normal",color:"#c43020" }}>open<br/>call.</em>
              </h1>
              <p style={{ fontSize:15,color:"rgba(26,18,9,0.45)",lineHeight:1.75,maxWidth:520,margin:"0 auto 36px" }}>
                Exhibitions, grants and residencies for Australian artists — apply directly, no middleman.
              </p>
              <div style={{ display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap",alignItems:"center" }}>
                <button className="btn-p" style={{ fontFamily:FUTURA,fontWeight:900,fontSize:11,letterSpacing:"0.1em",textTransform:"uppercase",padding:"14px 28px",background:"#1a1209",color:"#f0ece2",border:"none",borderRadius:3 }} onClick={()=>setView("opportunities")}>Browse Open Calls</button>
                <button style={{ fontFamily:"'DM Mono',monospace",fontSize:10,letterSpacing:"0.1em",textTransform:"uppercase",color:"rgba(26,18,9,0.4)",background:"none",border:"none",padding:"14px 0",cursor:"pointer" }} onClick={onSignupArtist}>Join as Artist →</button>
              </div>
            </div>
          </div>

          {/* For artists / galleries */}
          <div style={{ padding:"52px 24px",background:"#f0ece2" }}>
            <div style={{ maxWidth:900,margin:"0 auto",display:"grid",gridTemplateColumns:bp==="mobile"?"1fr":"1fr 1fr",gap:16 }}>
              <div style={{ background:"#ffffff",border:"1px solid rgba(26,18,9,0.08)",borderRadius:4,padding:"26px" }}>
                <div style={{ fontFamily:"'DM Mono',monospace",fontSize:".6rem",color:"rgba(26,18,9,0.35)",letterSpacing:"2px",textTransform:"uppercase",marginBottom:10 }}>For Artists</div>
                <h3 style={{ fontFamily:FUTURA,fontWeight:900,fontSize:"1.2rem",textTransform:"uppercase",color:"#1a1209",marginBottom:10 }}>Your practice. Your next show.</h3>
                <p style={{ fontSize:".82rem",color:"rgba(26,18,9,0.5)",lineHeight:1.75,marginBottom:16 }}>Build a public portfolio, browse open calls filtered by state and medium, and apply directly.</p>
                {["Public artist profile & portfolio","Browse exhibitions, grants & residencies","Track applications & statuses","Direct messaging with galleries"].map(f=>(
                  <div key={f} style={{ display:"flex",alignItems:"center",gap:9,fontSize:".8rem",color:"rgba(26,18,9,0.5)",marginBottom:8 }}>
                    <span style={{ width:18,height:18,borderRadius:"50%",background:"rgba(196,48,32,0.1)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:".58rem",color:"#c43020",flexShrink:0 }}>✓</span>{f}
                  </div>
                ))}
                <button className="btn-p" style={{ marginTop:18,width:"100%",background:"#c43020",color:"#f5ede8",fontFamily:FUTURA,fontWeight:900,textTransform:"uppercase",letterSpacing:"0.1em",borderRadius:3,border:"none" }} onClick={onSignupArtist}>Join as Artist →</button>
              </div>
              <div style={{ background:"#1a1209",borderRadius:4,padding:"26px" }}>
                <div style={{ fontFamily:"'DM Mono',monospace",fontSize:".6rem",color:"rgba(240,236,226,0.3)",letterSpacing:"2px",textTransform:"uppercase",marginBottom:10 }}>For Galleries</div>
                <h3 style={{ fontFamily:FUTURA,fontWeight:900,fontSize:"1.2rem",textTransform:"uppercase",color:"#f0ece2",marginBottom:10 }}>Post an open call. Find the right artist.</h3>
                <p style={{ fontSize:".82rem",color:"rgba(240,236,226,0.45)",lineHeight:1.75,marginBottom:16 }}>Publish exhibitions, grants or residencies with full details. Review folios and manage applications in one place.</p>
                {["Post & manage open calls","Browse Australian artist directory","Review & shortlist applications","Direct messaging to artists"].map(f=>(
                  <div key={f} style={{ display:"flex",alignItems:"center",gap:9,fontSize:".8rem",color:"rgba(240,236,226,0.45)",marginBottom:8 }}>
                    <span style={{ width:18,height:18,borderRadius:"50%",background:"rgba(212,148,10,0.15)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:".58rem",color:"#d4940a",flexShrink:0 }}>✓</span>{f}
                  </div>
                ))}
                <button className="btn-dk" style={{ marginTop:18,width:"100%",background:"#f0ece2",color:"#1a1209",fontFamily:FUTURA,fontWeight:900,textTransform:"uppercase",letterSpacing:"0.1em",borderRadius:3,border:"none" }} onClick={onSignupGallery}>Join as Gallery →</button>
              </div>
            </div>
          </div>

          {/* Opportunities preview */}
          <div style={{ padding:"52px 24px" }}>
            <div style={{ maxWidth:1060,margin:"0 auto" }}>
              <div style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginBottom:22 }}>
                <div><span className="slbl" style={{ marginBottom:6 }}>Latest</span><h2 style={{ fontFamily:FUTURA,fontWeight:900,fontSize:"1.5rem",textTransform:"uppercase",color:"#1a1209" }}>Open Calls</h2></div>
                <button className="btn-g" style={{ fontSize:".62rem",minHeight:40 }} onClick={()=>setView("opportunities")}>View all →</button>
              </div>
              <div className="opp-grid">
                {opportunities.slice(0,bp==="mobile"?2:4).map(o=>{
                  const tc = TYPE_CARD[o.type]||TYPE_CARD.open_call;
                  const tlen = (o.title||"").length;
                  return (
                    <div key={o.id} className="opp-card" onClick={()=>setModal(o)} style={{ background:"#ffffff",border:"1px solid rgba(26,18,9,0.08)",borderRadius:4 }}>
                      <div style={{ padding:"20px 18px 0",display:"flex",justifyContent:"space-between",alignItems:"flex-start" }}>
                        <span style={{ fontFamily:FUTURA,fontWeight:900,fontSize:9,letterSpacing:"0.22em",textTransform:"uppercase",color:tc.text }}>
                          {TYPE_STYLE[o.type]?.label||o.type}
                        </span>
                        <span style={{ fontFamily:"'DM Mono',monospace",fontSize:7,border:`1.5px solid ${tc.text}`,borderRadius:2,padding:"4px 9px",color:tc.text,background:"none" }}>
                          {o.entryFee}
                        </span>
                      </div>
                      <div style={{ fontFamily:FUTURA,fontWeight:900,textTransform:"uppercase",lineHeight:0.9,letterSpacing:"-0.02em",color:"#1a1209",padding:"16px 18px 22px",fontSize:tlen<=20?26:tlen<=30?20:16 }}>
                        {o.title}
                      </div>
                      <div style={{ background:tc.footerBg,padding:"18px",display:"grid",gridTemplateColumns:"1fr 1fr",gap:"12px 14px" }}>
                        {[["Who",o.eligibility||"All artists"],["Award",o.prize||o.entryFee||"No prize"],["Where",o.location||o.state],["Closes",o.deadline]].map(([k,v])=>(
                          <div key={k}>
                            <div style={{ fontFamily:"'DM Mono',monospace",fontSize:7,letterSpacing:"0.15em",textTransform:"uppercase",opacity:0.45,color:tc.footerText }}>{k}</div>
                            <div style={{ fontFamily:FUTURA,fontWeight:700,fontSize:11,textTransform:"uppercase",color:tc.footerText }}>{v}</div>
                          </div>
                        ))}
                        <div style={{ gridColumn:"1/-1",borderTop:"1px solid rgba(255,255,255,0.15)",paddingTop:6,fontFamily:"'DM Mono',monospace",fontSize:6,opacity:0.2,color:tc.footerText }}>opencall.com.au</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Footer */}
          <div style={{ background:"#1a1209",padding:"36px 48px" }}>
            <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24,flexWrap:"wrap",gap:16 }}>
              <Logo/>
              <div style={{ display:"flex",gap:24,flexWrap:"wrap" }}>
                {["Opportunities","Artists","For galleries","Contact"].map(l=>(
                  <span key={l} style={{ fontFamily:"'DM Mono',monospace",fontSize:9,letterSpacing:"0.12em",textTransform:"uppercase",color:"rgba(240,236,226,0.35)" }}>{l}</span>
                ))}
              </div>
            </div>
            <div style={{ borderTop:"1px solid rgba(255,255,255,0.08)",paddingTop:20,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10 }}>
              <div style={{ fontFamily:"'DM Mono',monospace",fontSize:8,color:"rgba(240,236,226,0.2)" }}>opencall. acknowledges the Traditional Custodians of Country throughout Australia.</div>
              <div style={{ fontFamily:"'DM Mono',monospace",fontSize:8,color:"rgba(240,236,226,0.2)" }}>© 2026 opencall.</div>
            </div>
          </div>
        </>}

        {/* OPPORTUNITIES */}
        {view==="opportunities"&&(
          <div style={{ maxWidth:1060,margin:"0 auto",padding:"32px 24px 80px" }}>
            <div style={{ marginBottom:24 }}>
              <h1 style={{ fontFamily:FUTURA,fontWeight:900,fontSize:"1.8rem",textTransform:"uppercase",color:"#1a1209",marginBottom:6 }}>Open Calls</h1>
              <p style={{ fontSize:".84rem",color:C.muted }}>All current opportunities for Australian artists.</p>
            </div>
            <div className="filter-bar">
              {["All","Exhibitions","Grants","Residencies"].map(t=>(
                <button key={t} className="filter-btn" style={{ background:typeF===t?"#1a1209":"transparent",color:typeF===t?"#f0ece2":"rgba(26,18,9,0.45)",border:typeF===t?"1.5px solid #1a1209":"1.5px solid rgba(26,18,9,0.12)" }} onClick={()=>setTypeF(t)}>{t}</button>
              ))}
              <div style={{ width:1,background:"rgba(26,18,9,0.12)",margin:"0 4px",flexShrink:0 }}/>
              {[["all","All"],["featured","Featured"],["open","Open"],["closing","Closing"]].map(([v,l])=>(
                <button key={v} className="filter-btn" style={{ background:tagF===v?"#1a1209":"transparent",color:tagF===v?"#f0ece2":"rgba(26,18,9,0.45)",border:tagF===v?"1.5px solid #1a1209":"1.5px solid rgba(26,18,9,0.12)" }} onClick={()=>setTagF(v)}>{l}</button>
              ))}
            </div>
            {filtered.length===0?(
              <div className="empty-state">
                <div style={{ fontSize:"2rem",marginBottom:12,opacity:.4 }}>🔍</div>
                <div style={{ fontFamily:"'Fraunces',serif",fontSize:"1.1rem",color:C.bark,marginBottom:8 }}>No matches</div>
                <button className="btn-g" onClick={()=>{setTypeF("All");setTagF("all");}}>Clear filters</button>
              </div>
            ):(
              <div className="opp-grid">
                {filtered.map(o=>{
                  const tc = TYPE_CARD[o.type]||TYPE_CARD.open_call;
                  const tlen = (o.title||"").length;
                  return (
                    <div key={o.id} className="opp-card" onClick={()=>setModal(o)} style={{ background:"#ffffff",border:"1px solid rgba(26,18,9,0.08)",borderRadius:4 }}>
                      <div style={{ padding:"20px 18px 0",display:"flex",justifyContent:"space-between",alignItems:"flex-start" }}>
                        <span style={{ fontFamily:FUTURA,fontWeight:900,fontSize:9,letterSpacing:"0.22em",textTransform:"uppercase",color:tc.text }}>
                          {TYPE_STYLE[o.type]?.label||o.type}
                        </span>
                        <span style={{ fontFamily:"'DM Mono',monospace",fontSize:7,border:`1.5px solid ${tc.text}`,borderRadius:2,padding:"4px 9px",color:tc.text,background:"none" }}>
                          {o.entryFee}
                        </span>
                      </div>
                      <div style={{ fontFamily:FUTURA,fontWeight:900,textTransform:"uppercase",lineHeight:0.9,letterSpacing:"-0.02em",color:"#1a1209",padding:"16px 18px 22px",fontSize:tlen<=20?26:tlen<=30?20:16 }}>
                        {o.title}
                      </div>
                      <div style={{ background:tc.footerBg,padding:"18px",display:"grid",gridTemplateColumns:"1fr 1fr",gap:"12px 14px" }}>
                        {[["Who",o.eligibility||"All artists"],["Award",o.prize||o.entryFee||"No prize"],["Where",o.location||o.state],["Closes",o.deadline]].map(([k,v])=>(
                          <div key={k}>
                            <div style={{ fontFamily:"'DM Mono',monospace",fontSize:7,letterSpacing:"0.15em",textTransform:"uppercase",opacity:0.45,color:tc.footerText }}>{k}</div>
                            <div style={{ fontFamily:FUTURA,fontWeight:700,fontSize:11,textTransform:"uppercase",color:tc.footerText }}>{v}</div>
                          </div>
                        ))}
                        <div style={{ gridColumn:"1/-1",borderTop:"1px solid rgba(255,255,255,0.15)",paddingTop:6,fontFamily:"'DM Mono',monospace",fontSize:6,opacity:0.2,color:tc.footerText }}>opencall.com.au</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* ARTISTS */}
        {view==="artists"&&(
          <div style={{ maxWidth:1060,margin:"0 auto",padding:"32px 24px 80px" }}>
            <div style={{ marginBottom:24 }}>
              <h1 style={{ fontFamily:FUTURA,fontWeight:900,fontSize:"1.8rem",textTransform:"uppercase",color:"#1a1209",marginBottom:6 }}>Artist Directory</h1>
              <p style={{ fontSize:".84rem",color:C.muted }}>Browse artist profiles and portfolios across Australia.</p>
            </div>
            <div className="artist-grid">
              {artists.map(a=>(
                <div key={a.id} className="artist-card">
                  {a.firstNations&&<span style={{ position:"absolute",top:12,right:12,fontSize:".54rem",fontFamily:"'DM Mono',monospace",color:C.clay,background:"rgba(193,127,74,.12)",border:`1px solid rgba(193,127,74,.25)`,borderRadius:"2px",padding:"2px 6px",letterSpacing:"1px",textTransform:"uppercase" }}>First Nations</span>}
                  <div style={{ display:"flex",gap:12,alignItems:"center",marginBottom:12 }}>
                    <div style={{ width:44,height:44,borderRadius:"50%",background:`linear-gradient(135deg,${C.clay},${C.barkL})`,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'DM Mono',monospace",fontSize:".68rem",color:"#fff",flexShrink:0 }}>{a.av}</div>
                    <div><div style={{ fontFamily:"'Fraunces',serif",fontSize:".95rem",color:C.bark }}>{a.name}</div><div style={{ fontSize:".7rem",color:C.muted }}>{a.title}</div></div>
                  </div>
                  <div style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:4,marginBottom:10,borderRadius:4,overflow:"hidden" }}>
                    {(a.portfolioImages?.length > 0 ? a.portfolioImages.slice(0,3) : [null,null,null]).map((url,i)=>(
                      <div key={i} style={{ height:52,background:url?'#f0e2cc':a.color,opacity:0.5+i*.2,overflow:'hidden',display:'flex',alignItems:'center',justifyContent:'center' }}>
                        {url
                          ? <img src={url} alt="" style={{ width:'100%',height:'100%',objectFit:'cover' }}/>
                          : <span style={{ fontSize:'.85rem' }}>🖼️</span>
                        }
                      </div>
                    ))}
                  </div>
                  <div style={{ display:"flex",flexWrap:"wrap",gap:5,marginBottom:10 }}>
                    {(a.mediums||[]).map(m=><span key={m} className="pill">{m}</span>)}
                  </div>
                  <div style={{ display:"flex",justifyContent:"space-between",fontSize:".68rem",color:C.muted,fontFamily:"'DM Mono',monospace",paddingTop:8,borderTop:`1px solid ${C.parchD}` }}>
                    <span>📍 {a.location}</span><span>{a.shows} shows →</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Mobile bottom tabs */}
      {bp!=="desktop"&&(
        <div className="bottom-tabs">
          {NAV.map(n=>(
            <button key={n.id} className={`tab-btn ${view===n.id?"on":""}`} onClick={()=>setView(n.id)}>
              <span className="tab-icon">{{home:"🏠",opportunities:"📋",artists:"👥"}[n.id]}</span>{n.label}
            </button>
          ))}
          <button className="tab-btn" onClick={()=>setSearching(true)}><span className="tab-icon">🔍</span>Search</button>
          <button className="tab-btn" onClick={onSignupArtist}><span className="tab-icon">◎</span>Join</button>
        </div>
      )}

      {modal&&<OppModal item={modal} onClose={()=>setModal(null)} currentProfile={currentProfile}/>}
    </>
  );
}
